export default "__VITE_ASSET__ClxWvEi8__"